// test2971
(2971 && 0);
